import { render, staticRenderFns } from "./benefitsCard.vue?vue&type=template&id=ddeba088&scoped=true"
import script from "./benefitsCard.vue?vue&type=script&lang=js"
export * from "./benefitsCard.vue?vue&type=script&lang=js"
import style0 from "./benefitsCard.vue?vue&type=style&index=0&id=ddeba088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddeba088",
  null
  
)

export default component.exports